import app from 'app';
import mxConfirmationModal from 'components/modals/mxConfirmationModal/mxConfirmationModal';
import mxRegisteredModal from 'components/modals/mxRegisteredModal/mxRegisteredModal';
import { setUserIdentifier } from 'helpers/userIdentifier';

app.service('RegistrationForm', ($state, chModal, Session, Redirect) => {
  function openRegisteredConfirmationModal() {
    Redirect.redirectTo();
    chModal.open({
      component: mxRegisteredModal,
    });
  }

  function openCheckEmailModal() {
    chModal.open({
      component: mxConfirmationModal,
      locals: {
        body: `You should receive an email from us shortly containing a link to verify your email.
         If you don't see it in the next few minutes (and it's not in your Spam folder) send us
         a message or give us a ring at 844-803-0210`,
        confirm: 'Close',
        header: 'Almost there...',
      },
    });
  }

  function handleRegistrationSuccess(response) {
    if (response.userIdentifier) {
      setUserIdentifier(response.userIdentifier);
    }

    if (response.loginToken) {
      Session.beginSession(response.loginToken);
      const session = Session.getSession();

      if (session.isVerified) {
        openRegisteredConfirmationModal();
      } else {
        // Auth Interceptor causes redirect to login because token isn't verified.
        // So we logout the user to clear the session token
        Session.logout();
        $state.go('ConfirmEmail', { email: session.email });
      }
    } else {
      $state.go('Login').then(openCheckEmailModal);
    }
  }

  return {
    handleRegistrationSuccess,
  };
});
